import React, { useEffect, useRef, useState } from 'react';
import { useLang } from '../../i18n/LanguageContext';
import { Link } from 'react-router-dom';

const CTASection = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.2 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} style={{ background: 'radial-gradient(130% 100% at 50% 0%, #221A63 0%, #100C33 45%, #06041A 100%)', padding: '110px 24px', position: 'relative', overflow: 'hidden' }}>
      <style>{`
        @keyframes ctaBlob {
          0%, 100% { transform: translate(0,0) scale(1); }
          50% { transform: translate(30px,-20px) scale(1.08); }
        }
        .cta-primary-btn {
          transition: all 0.2s ease;
        }
        .cta-primary-btn:hover {
          filter: brightness(1.08);
          transform: translateY(-2px) !important;
          box-shadow: 0 8px 24px rgba(0,0,0,0.2) !important;
        }
        .cta-secondary-btn {
          transition: all 0.2s ease;
        }
        .cta-secondary-btn:hover {
          background: rgba(255,255,255,0.12) !important;
          transform: translateY(-2px) !important;
        }
        @media (max-width: 640px) {
          .cta-br { display: none; }
        }
      `}</style>

      {/* Subtle decorative blobs */}
      <div style={{ position: 'absolute', top: '-20%', left: '-10%', width: 600, height: 600, borderRadius: '50%', background: 'radial-gradient(circle, rgba(255,255,255,0.04) 0%, transparent 65%)', filter: 'blur(60px)', animation: 'ctaBlob 12s ease-in-out infinite', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: '-20%', right: '-10%', width: 500, height: 500, borderRadius: '50%', background: 'radial-gradient(circle, rgba(79,70,229,0.25) 0%, transparent 65%)', filter: 'blur(80px)', pointerEvents: 'none' }} />

      <div style={{ maxWidth: 860, margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <div style={{
          textAlign: 'center',
          opacity: visible ? 1 : 0,
          transform: visible ? 'none' : 'translateY(24px)',
          transition: 'all 0.7s ease',
        }}>
          {/* Tag */}
          <span style={{ display: 'inline-block', padding: '5px 18px', borderRadius: 999, background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', color: 'rgba(255,255,255,0.75)', fontSize: 12, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 28 }}>
            {t('landing.cta.tag')}
          </span>

          {/* Headline */}
          <h2 style={{ fontSize: 'clamp(28px,5vw,54px)', fontWeight: 900, color: '#fff', letterSpacing: '-0.03em', lineHeight: 1.12, marginBottom: 18 }}>
            {t('landing.cta.title1')}<br className="cta-br" />{' '}
            <span style={{ color: 'rgba(255,255,255,0.6)' }}>{t('landing.cta.title2')}</span>
          </h2>

          {/* Sub */}
          <p style={{ fontSize: 'clamp(14px,2vw,17px)', color: 'rgba(255,255,255,0.55)', maxWidth: 520, margin: '0 auto 40px', lineHeight: 1.7 }}>
            {t('landing.cta.sub')}
          </p>

          {/* CTAs */}
          <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap', marginBottom: 32 }}>
            <Link
              to="/signup"
              className="cta-primary-btn"
              style={{
                padding: '15px 40px',
                borderRadius: 12,
                background: 'linear-gradient(135deg,#6D5DFB,#4F46E5 55%,#3B82F6)',
                color: '#fff', fontWeight: 700, fontSize: 15,
                textDecoration: 'none',
                boxShadow: '0 12px 36px -8px rgba(109,93,251,.65)',
                display: 'inline-block',
              }}
            >
              {t('landing.cta.primary')}
            </Link>
            <Link
              to="/login"
              className="cta-secondary-btn"
              style={{
                padding: '15px 40px',
                borderRadius: 12,
                background: 'rgba(255,255,255,0.08)',
                border: '1px solid rgba(255,255,255,0.2)',
                color: 'rgba(255,255,255,0.8)', fontWeight: 600, fontSize: 15,
                textDecoration: 'none',
                display: 'inline-block',
              }}
            >
              {t('landing.cta.secondary')} →
            </Link>
          </div>

          {/* Trust row */}
          <div style={{ display: 'flex', gap: 24, justifyContent: 'center', flexWrap: 'wrap' }}>
            {[t('landing.cta.trust1'), t('landing.cta.trust2'), t('landing.cta.trust3')].map((label, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: 'rgba(255,255,255,0.4)' }}>
                <span style={{ color: '#34d399', fontSize: 10 }}>✓</span> {label}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
